export default __webpack_public_path__ + "static/floral-texture-4e32fb0970518982c385d7961dcb9c40.png";